import { PureComponent } from "react";
import PropTypes from "prop-types";
import L from "leaflet";

/**
 * Aquest component carrega la capa base en gris amb comarques del SMC. S'ha possat en un component apart
 * per poder tractar el zoom. Donat que les tiles d'origen sempre tenen dos digits i el objecte TileLayer
 * de leaflet pot arribar a enviar només un digit.
 *
 */

const LeafletBaseSMCLayer = L.TileLayer.extend({
  getTileUrl: function(coords) {
    //Només tenim que assegurar-nos que el zoom te dos dígits
    let z = "0" + this._getZoomForUrl();
    z = z.slice(-2);

    var data = {
      r: L.Browser.retina ? "@2x" : "",
      s: this._getSubdomain(coords),
      x: coords.x,
      y: coords.y,
      z: z
    };
    if (this._map && !this._map.options.crs.infinite) {
      var invertedY = this._globalTileRange.max.y - coords.y;
      if (this.options.tms) {
        data["y"] = invertedY;
      }
      data["-y"] = invertedY;
    }

    return L.Util.template(this._url, L.Util.extend(data, this.options));
  }
});

class BaseSMCLayer extends PureComponent {
  constructor(props) {
    super(props);

    const { lMap, url, lControl, name, options } = props;

    if (lMap === null) {
      return;
    }

    //Aplicar recorte segun geojson
    const layer = new LeafletBaseSMCLayer(url, { ...options });

    lControl.addBaseLayer(layer, name);

    this.name = name;
    this.layer = layer;
  }

  render() {
    return null;
  }
}

BaseSMCLayer.propTypes = {
  url: PropTypes.string,
  options: PropTypes.object,
  name: PropTypes.string,
  lMap: PropTypes.object,
  lControl: PropTypes.object
};

export default BaseSMCLayer;
